import { render, staticRenderFns } from "./PlayerPendingInfoRewardLetter.vue?vue&type=template&id=1f83510e&scoped=true&"
import script from "./PlayerPendingInfoRewardLetter.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingInfoRewardLetter.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPendingInfoRewardLetter.vue?vue&type=style&index=0&id=1f83510e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83510e",
  null
  
)

export default component.exports